import React from "react";
import styled from "styled-components";
import useLanding from "../../../../hooks/useLanding";
import Text from "../../../common/Text";
import parse from "html-react-parser";

const List = () => {
    const { code, description } = useLanding();

    if (!!code) {
        return (
            <Container>
                {parse(description) || (
                    <>
                        <Text fontSize={"22px"} fontWeight="bold">
                            Regístrate siguiendo estos pasos:
                        </Text>
                        <ListItem>
                            <Text fontWeight="bold" color="#666">
                                1) Completa el formulario de inscripción.
                            </Text>
                            <Text fontWeight="bold" color="#666">
                                2) Expande tu conocimiento.
                            </Text>
                            <Text fontWeight="bold" color="#666">
                                3) Al finalizar, descarga tu certificado
                                AcrópolisLab.
                            </Text>
                        </ListItem>
                    </>
                )}
            </Container>
        );
    }

    return (
        <Container>
            <Text fontSize={"22px"} fontWeight="bold">
                Regístrate siguiendo estos pasos:
            </Text>
            <ListItem>
                <Text fontWeight="bold" color="#666">
                    1) Ingresa el código que tu Asesor Académico te compartió.
                </Text>
                <Text fontWeight="bold" color="#666">
                    2) Completa el formulario de inscripción.
                </Text>
                <Text fontWeight="bold" color="#666">
                    3) Comienza el cursado.
                </Text>
                <Text fontWeight="bold" color="#666">
                    4) Al finalizar, descarga tu certificado AcrópolisLab.
                </Text>
            </ListItem>
        </Container>
    );
};

export default List;

const Container = styled.div`
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 2rem;
    box-sizing: border-box;

    h1 {
        font-size: 32px;
        font-weight: 700;
        margin: 1.5rem 0 1rem 0;
        color: #333;
        line-height: 1.3;
    }

    h2 {
        font-size: 24px;
        font-weight: 700;
        margin: 1.5rem 0 1rem 0;
        color: #333;
        line-height: 1.3;
    }

    h3 {
        font-size: 20px;
        font-weight: 700;
        margin: 1rem 0 0.5rem 0;
        color: #333;
        line-height: 1.3;
    }

    p {
        font-size: 16px;
        line-height: 1.6;
        margin: 0.5rem 0;
        color: #666;
    }

    ul, ol {
        margin: 1rem 0;
        padding-left: 2rem;
    }

    li {
        font-size: 16px;
        line-height: 1.8;
        margin: 0.5rem 0;
        color: #666;
    }

    strong {
        font-weight: 700;
        color: #333;
    }

    @media (max-width: 768px) {
        padding: 1.5rem;
    }
`;

const ListItem = styled.div`
    margin-top: 3rem;
    display: flex;
    gap: 24px;
    flex-direction: column;
    justify-content: flex-start;
`;
